import { Injectable } from '@angular/core';
import { CommandHandlerResolver } from './command-handler-resolver.service';
import { EditCommandHandler } from './edit-command-handler.service';
import { DeleteCommandHandler } from './delete-command-handler.service';
import { standardCommand } from '../../model/command';

@Injectable()
export class StandardCommandHandlerResolver extends CommandHandlerResolver {
  constructor(deleteHandler: DeleteCommandHandler, editHandler: EditCommandHandler) {
    super();
    this.addHandler(standardCommand.delete, deleteHandler);
    this.addHandler(standardCommand.edit, editHandler);
  }
}
